<template>
    <div>
         <v-data-table
            dense
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="precenseKitchenSummaryLoadStatus===1"
            disable-pagination
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Kuchnia</v-toolbar-title>
                <v-spacer />
                <v-menu
                                        v-model="selectedDayMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            v-model="selectedDay"
                                            label="Data"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="choose_date mt-6 mr-5"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker first-day-of-week="1" v-model="selectedDay" @input="selectedDayMenu = false"></v-date-picker>
                  </v-menu>
                  <v-btn class="ml-2" @click="printFile" x-small :disabled="tableItems.length<1" color="primary">drukuj</v-btn>  
              </v-toolbar>
            </template>
      
            <template v-slot:item.diet_children="{ item }">
               <div v-for="c in item.diet_children" :key="c"><span>{{c}}</span></div>
            </template>

            <template v-if="tableItems.length>0" slot="body.append">
                <tr class="v-data-table__selected font-weight-medium subheading">
                        <td></td>
                        <td>Suma</td>
                        <!-- <td>{{ options.lineCount }}</td> -->
                        <td>{{ sumField('breakfast')}}</td>
                        <td>{{ sumField('lunch')}}</td>
                        <td>{{ sumField('tea')}}</td>
                        <td>{{ sumField('diet')}}</td>
                </tr>
            </template>
            
          </v-data-table> 
        </div>
</template>

<script>
     
  import jsPDF from 'jspdf'
  import logusLogo from '../plugins/jspdf_resources'
  import 'jspdf-autotable'

  export default {
    data: () => ({
      componentKey:0,
      headers: [
        { text: 'Grupa', value: 'course_name',filterable:false,filterColumn:"course_name",display:true },
        { text: 'Placówka', value: 'department_name',filterable:false,filterColumn:"department_name",display:true },
        { text: 'Śniadanie', value: 'breakfast',filterable:false,filterColumn:"breakfast",display:true },
        { text: 'Obiad', value: 'lunch',filterable:false,filterColumn:"lunch",display:true },
        { text: 'Podwieczorek', value: 'tea',filterable:false,filterColumn:"tea",display:true },
        { text: 'Dieta', value: 'diet',filterable:false,filterColumn:"diet",display:true },
        { text: 'Dzieci', value: 'diet_children',filterable:false,filterColumn:"diet_children",display:false },
      ],
      selected:null,
      selectedDayMenu:false
    }),
    watch: {
   
    },
    mounted(){
      this.loadKitchenSummary();
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      tableItems(){
        return this.$store.getters.getPresenceKitchenSummary;
      },
      precenseKitchenSummaryLoadStatus(){
        return this.$store.getters.getPresenceKitchenSummaryLoadStatus;
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]
        return localHeaders
      },  
      selectedDay:{
        get () {
          return this.selected || (new Date()).toISOString().substr(0,10);
        },
        set (value) {
          this.selected = value;
          this.loadKitchenSummary();
        }
      },
    },
    methods: {
      loadKitchenSummary(){
        if(this.user.permissions['desktop'] >=5){
          this.$store.dispatch( 'loadKitchenSummary',{selectedDay:this.selectedDay} );
        }
      },
      sumField(key) {
        return this.tableItems.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
      // downloadSummaryFile(){
      //   //przygotowanie danych
      //   var items = []
      //   this.tableItems.forEach(item => {
      //     items.push({course_name:item.course_name, department_name:item.department_name, breakfast:item.breakfast, 
      //     lunch:item.lunch, tea:item.tea, diet:item.diet})
      //   });

      //   var wb = XLSX.utils.book_new()
      //   var ws_name = "Zestawienie";
      //   var ws = XLSX.utils.aoa_to_sheet([["Grupa","Placówka","Śniadanie","Obiad","Podwieczorek","Dieta","Dzieci"]]);
      //   XLSX.utils.sheet_add_json(ws,items,{header:["course_name","department_name","breakfast","lunch","tea","diet"], skipHeader:true, origin:1})
        
      //   XLSX.utils.book_append_sheet(wb, ws, ws_name);
      
      //   var rightNow = new Date();
      //   rightNow.setMinutes(rightNow.getMinutes() - rightNow.getTimezoneOffset());
      //   var filename = 'Kuchnia_' + selected.replace('-','_') +'.xlsx';
      //   XLSX.writeFile(wb, filename, {})

      // },
      generatePDF(){
        var items = []
        var page = 1;
        this.tableItems.sort((a,b)=>(a.course_name>b.course_name)?1:(b.course_name>a.course_name)?-1:0).forEach(item => {
          items.push([item.course_name,item.department_name,item.breakfast,item.lunch,item.tea,item.diet,item.diet_children.join('\n')]);
        });

        var doc = new jsPDF({
          //orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        doc.setFont("Roboto-Medium", "bold"); // set font
        doc.setFontSize(14);
        doc.addImage(logusLogo, 'PNG', 5, 5, 22.5, 20);
        doc.text('Kuchnia', pageWidth-5, 12, {align:'right',baseline:'bottom'});
        doc.text(this.selectedDay, pageWidth-5, 20, {align:'right',baseline:'bottom'});
        //doc.setFontSize(12);
        //doc.text(this.editedItem.child.name+' '+this.editedItem.child.surname, pageWidth-5, 12, {align:'right'});
        doc.setFont("Roboto-Regular", "normal"); // set font
        doc.setFontSize(10);
        doc.autoTable({
          didDrawPage: (data) => {
            //doc.text(page.toString(), 5, pageHeight-5);
            doc.text(page.toString(), pageWidth/2, pageHeight-5, {align:'center',baseline:'bottom'});
            //doc.text(this.editedItem.created_by+' / '+this.editedItem.created_at, pageWidth-5, pageHeight-5, {align:'right'});
            page++;
          },
          theme:'grid',
          styles:{font:'Roboto-Regular', fontSize:9 },
          headStyles: { fillColor: [210, 210, 210],textColor:20 },
          footStyles: { fillColor: [210, 210, 210],textColor:20 },
          startY: 30,
          showFoot:'lastPage',
          margin: {top:5,bottom:10,left:5,right:5},
          //columnStyles: { 3: {font:'Roboto-Medium', halign: 'right' },4: {font:'Roboto-Medium', halign: 'right' }, 5: {font:'Roboto-Medium', halign: 'right' },6: {font:'Roboto-Medium', halign: 'right' } },
          head: [_.map(this.headers,'text')],
          body: items,
          foot: [
            [
              { content: 'Suma', colSpan: 2, styles: {font:'Roboto-Medium',fontStyle:'bold', halign: 'left' } },
              { content: this.sumField('breakfast'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
              { content: this.sumField('lunch'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
              { content: this.sumField('tea'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
              { content: this.sumField('diet'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'left' }},
            ],
          ],
        })
        
        return doc;
      },
      printFile(){
        var doc = this.generatePDF();
        doc.autoPrint();
        doc.output('dataurlnewwindow');
        doc.close();
      },
    },
  }
</script>
<style scoped>
.search{
      max-width: 250px;
}
.choose_date{
      max-width: 150px;
}
</style>